<div class="modalBase w-100">
  <span class="btn_Close" (click)="close()"><i class="fas fa-times-circle"></i></span>
  <div class="pt-4 pb-4 pr-5 pl-5">
    <div class="text-center mb-4">
      <span class="titulo">Vincular cuentas</span>
    </div>
    <p class="text-muted text-center mb-4" style="font-size: 13px;">
      Vincula tus cuentas de Google o Microsoft para iniciar sesión más rápido.
      Conectar Google además te permite enviar documentos a tu Drive desde Flows.
    </p>

    @if (message) {
      <ngb-alert [type]="messageType" (close)="message = ''">{{ message }}</ngb-alert>
    }

    <div class="oauth-row">
      <div class="oauth-item">
        <div class="oauth-icon">
          <svg width="24" height="24" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
        </div>
        <div class="oauth-info">
          <strong>Google</strong>
          @if (googleLinked && googleDrive) {
            <span class="badge-linked">Vinculada · Drive</span>
          } @else if (googleLinked) {
            <span class="badge-unlinked">Vinculada · sin Drive</span>
          } @else {
            <span class="badge-unlinked">No vinculada</span>
          }
          @if (googleEmail) {
            <div class="text-muted text-truncate" style="font-size:11px;">{{googleEmail}}</div>
          }
        </div>
        <div class="oauth-action">
          @if (googleLinked && !googleDrive) {
            <!-- Vinculada antes de unificar los flujos: falta el permiso de Drive -->
            <button class="btn btn-sm btn-outline-primary" (click)="linkGoogle()">Habilitar Drive</button>
          } @else if (googleLinked) {
            <button class="btn btn-sm btn-outline-danger" (click)="unlinkGoogle()">Desvincular</button>
          } @else {
            <button class="btn btn-sm btn-outline-primary" (click)="linkGoogle()">Vincular</button>
          }
        </div>
      </div>

      <div class="oauth-item">
        <div class="oauth-icon">
          <svg width="24" height="24" viewBox="0 0 21 21"><rect x="1" y="1" width="9" height="9" fill="#f25022"/><rect x="1" y="11" width="9" height="9" fill="#00a4ef"/><rect x="11" y="1" width="9" height="9" fill="#7fba00"/><rect x="11" y="11" width="9" height="9" fill="#ffb900"/></svg>
        </div>
        <div class="oauth-info">
          <strong>Microsoft</strong>
          @if (microsoftLinked) {
            <span class="badge-linked">Vinculada</span>
          } @else {
            <span class="badge-unlinked">No vinculada</span>
          }
        </div>
        <div class="oauth-action">
          @if (microsoftLinked) {
            <button class="btn btn-sm btn-outline-danger" (click)="unlinkMicrosoft()">Desvincular</button>
          } @else {
            <button class="btn btn-sm btn-outline-primary" (click)="linkMicrosoft()">Vincular</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
